module.exports = __webpack_public_path__ + "static/img/desktop-gwgl.c125e0a4.png";